module.exports = __webpack_public_path__ + "static/media/beneficiary.e0fd0c95.jpg";